import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import RegisteredInput from '@common/hook-form/registered-input';
import { assignTestId } from '@common/infra/tests/assign-test-id';
export function UserOAuthSubjectField(props) {
    const { disabled, className } = props;
    const { control } = useFormContext();
    return (_jsx(RegisteredInput, { label: "OAuth subject", name: "subject", autoComplete: "off", control: control, disabled: disabled, className: className, ...assignTestId('form-oauth-subject') }));
}
